/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApproveDayCommand
 */
export interface ApproveDayCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApproveDayCommand
     */
    employeeIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApproveDayCommand
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof ApproveDayCommand
     */
    endDate: string;
}

/**
 * Check if a given object implements the ApproveDayCommand interface.
 */
export function instanceOfApproveDayCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "employeeIds" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;

    return isInstance;
}

export function ApproveDayCommandFromJSON(json: any): ApproveDayCommand {
    return ApproveDayCommandFromJSONTyped(json, false);
}

export function ApproveDayCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveDayCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'employeeIds': json['employeeIds'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
    };
}

export function ApproveDayCommandToJSON(value?: ApproveDayCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'employeeIds': value.employeeIds,
        'startDate': value.startDate,
        'endDate': value.endDate,
    };
}

